<template>
  404 - Page not found
</template>

<script setup>

</script>
